import { render } from "./Edit.vue?vue&type=template&id=71fe9956"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=71fe9956&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/eleve/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71fe9956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71fe9956', __exports__)) {
    console.log('reload')
    api.reload('71fe9956', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=71fe9956", () => {
    console.log('re-render')
    api.rerender('71fe9956', render)
  })

}


export default __exports__